var _defs, _path, _text, _line, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetVertivioLockup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 150",
    role: "img",
    "aria-label": "RESET powered by Vertivio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24be9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2778e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10195a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 18a54 54 0 1 0 48 79h-31a28 28 0 1 1 3-42L72 75h70V18h-24v19A54 54 0 0 0 72 18Z",
    fill: "url(#r)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 92,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 58,
    letterSpacing: 12,
    fontWeight: 800,
    fill: "#081333"
  }, "RESET")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 474,
    y1: 30,
    x2: 474,
    y2: 118,
    stroke: "#a7b0c2",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 61,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 18,
    letterSpacing: 4,
    fontWeight: 800,
    fill: "#5c6785"
  }, "POWERED BY")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 98,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 34,
    letterSpacing: 9,
    fontWeight: 800,
    fill: "#19a982"
  }, "VERTIVIO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetVertivioLockup);
export default __webpack_public_path__ + "static/media/reset-vertivio-lockup.62ff7b8bc1411530f3725deefa804755.svg";
export { ForwardRef as ReactComponent };